// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import { addAssetToLibraryApiAssetsAssetIdLibraryPost, attachProjectAssetApiProjectsProjectIdAssetsPost, createAssetApiAssetsPost, createImageAssetApiAssetsImagePost, createProjectApiProjectsPost, deleteAllSessionsApiSessionsDelete, deleteImageApiImagesImageIdDelete, deleteSessionApiSessionsSessionIdDelete, downloadImageApiImagesImageIdDownloadGet, downloadUpscaledImageApiImagesImageIdDownloadUpscaledGet, expandElementsApiImagesImageIdParametersExpandElementsPost, expandGroupParametersApiImagesImageIdParametersExpandGroupPost, extractParametersFromImageApiImagesImageIdParametersPost, getGalleryTreeApiSessionsGalleryTreeGet, getImageAssetsApiImagesImageIdAssetsGet, getImageByIdApiImagesImageIdGet, getImageIterationPathApiImagesImageIdIterationPathGet, getMyStatusApiUsersMeGet, getSessionWithHierarchyApiSessionsSessionIdGet, handleClerkWebhookApiWebhooksClerkPost, healthCheckHealthGet, listAssetsApiAssetsGet, listCatalogApiAssetsCatalogGet, listCatalogCategoriesApiAssetsCatalogCategoriesGet, listCatalogManufacturersApiAssetsCatalogManufacturersGet, listImagesApiImagesGet, listOrgsApiAdminOrgsGet, listProjectAssetsApiProjectsProjectIdAssetsGet, listSessionsApiSessionsGet, listUsersApiAdminUsersGet, markWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPost, moveSessionToProjectApiSessionsSessionIdProjectPatch, type Options, pingApiPingGet, renameProjectApiProjectsProjectIdPatch, renameSessionApiSessionsSessionIdPatch, saveImageAsAssetApiImagesImageIdSaveAsAssetPost, shareAssetWithOrgApiAssetsAssetIdShareWithOrgPost, transcribeAudioApiTranscribePost, updateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatch, updateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatch, uploadImageApiAssetsImageUploadPost, uploadImageApiImagesUploadPost } from '../sdk.gen';
import type { AddAssetToLibraryApiAssetsAssetIdLibraryPostData, AddAssetToLibraryApiAssetsAssetIdLibraryPostError, AddAssetToLibraryApiAssetsAssetIdLibraryPostResponse, AttachProjectAssetApiProjectsProjectIdAssetsPostData, AttachProjectAssetApiProjectsProjectIdAssetsPostError, AttachProjectAssetApiProjectsProjectIdAssetsPostResponse, CreateAssetApiAssetsPostData, CreateAssetApiAssetsPostError, CreateAssetApiAssetsPostResponse, CreateImageAssetApiAssetsImagePostData, CreateImageAssetApiAssetsImagePostError, CreateImageAssetApiAssetsImagePostResponse, CreateProjectApiProjectsPostData, CreateProjectApiProjectsPostError, CreateProjectApiProjectsPostResponse, DeleteAllSessionsApiSessionsDeleteData, DeleteAllSessionsApiSessionsDeleteError, DeleteAllSessionsApiSessionsDeleteResponse, DeleteImageApiImagesImageIdDeleteData, DeleteImageApiImagesImageIdDeleteError, DeleteImageApiImagesImageIdDeleteResponse, DeleteSessionApiSessionsSessionIdDeleteData, DeleteSessionApiSessionsSessionIdDeleteError, DeleteSessionApiSessionsSessionIdDeleteResponse, DownloadImageApiImagesImageIdDownloadGetData, DownloadImageApiImagesImageIdDownloadGetError, DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetData, DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetError, ExpandElementsApiImagesImageIdParametersExpandElementsPostData, ExpandElementsApiImagesImageIdParametersExpandElementsPostError, ExpandElementsApiImagesImageIdParametersExpandElementsPostResponse, ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostData, ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostError, ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostResponse, ExtractParametersFromImageApiImagesImageIdParametersPostData, ExtractParametersFromImageApiImagesImageIdParametersPostError, ExtractParametersFromImageApiImagesImageIdParametersPostResponse, GetGalleryTreeApiSessionsGalleryTreeGetData, GetGalleryTreeApiSessionsGalleryTreeGetError, GetGalleryTreeApiSessionsGalleryTreeGetResponse, GetImageAssetsApiImagesImageIdAssetsGetData, GetImageAssetsApiImagesImageIdAssetsGetError, GetImageAssetsApiImagesImageIdAssetsGetResponse, GetImageByIdApiImagesImageIdGetData, GetImageByIdApiImagesImageIdGetError, GetImageByIdApiImagesImageIdGetResponse, GetImageIterationPathApiImagesImageIdIterationPathGetData, GetImageIterationPathApiImagesImageIdIterationPathGetError, GetImageIterationPathApiImagesImageIdIterationPathGetResponse, GetMyStatusApiUsersMeGetData, GetMyStatusApiUsersMeGetError, GetMyStatusApiUsersMeGetResponse, GetSessionWithHierarchyApiSessionsSessionIdGetData, GetSessionWithHierarchyApiSessionsSessionIdGetError, GetSessionWithHierarchyApiSessionsSessionIdGetResponse, HandleClerkWebhookApiWebhooksClerkPostData, HandleClerkWebhookApiWebhooksClerkPostError, HealthCheckHealthGetData, HealthCheckHealthGetError, ListAssetsApiAssetsGetData, ListAssetsApiAssetsGetError, ListAssetsApiAssetsGetResponse, ListCatalogApiAssetsCatalogGetData, ListCatalogApiAssetsCatalogGetError, ListCatalogApiAssetsCatalogGetResponse, ListCatalogCategoriesApiAssetsCatalogCategoriesGetData, ListCatalogCategoriesApiAssetsCatalogCategoriesGetError, ListCatalogCategoriesApiAssetsCatalogCategoriesGetResponse, ListCatalogManufacturersApiAssetsCatalogManufacturersGetData, ListCatalogManufacturersApiAssetsCatalogManufacturersGetError, ListCatalogManufacturersApiAssetsCatalogManufacturersGetResponse, ListImagesApiImagesGetData, ListImagesApiImagesGetError, ListImagesApiImagesGetResponse, ListOrgsApiAdminOrgsGetData, ListOrgsApiAdminOrgsGetError, ListOrgsApiAdminOrgsGetResponse, ListProjectAssetsApiProjectsProjectIdAssetsGetData, ListProjectAssetsApiProjectsProjectIdAssetsGetError, ListProjectAssetsApiProjectsProjectIdAssetsGetResponse, ListSessionsApiSessionsGetData, ListSessionsApiSessionsGetError, ListSessionsApiSessionsGetResponse, ListUsersApiAdminUsersGetData, ListUsersApiAdminUsersGetError, ListUsersApiAdminUsersGetResponse, MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostData, MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostError, MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostResponse, MoveSessionToProjectApiSessionsSessionIdProjectPatchData, MoveSessionToProjectApiSessionsSessionIdProjectPatchError, MoveSessionToProjectApiSessionsSessionIdProjectPatchResponse, PingApiPingGetData, PingApiPingGetError, PingApiPingGetResponse, RenameProjectApiProjectsProjectIdPatchData, RenameProjectApiProjectsProjectIdPatchError, RenameProjectApiProjectsProjectIdPatchResponse, RenameSessionApiSessionsSessionIdPatchData, RenameSessionApiSessionsSessionIdPatchError, RenameSessionApiSessionsSessionIdPatchResponse, SaveImageAsAssetApiImagesImageIdSaveAsAssetPostData, SaveImageAsAssetApiImagesImageIdSaveAsAssetPostError, SaveImageAsAssetApiImagesImageIdSaveAsAssetPostResponse, ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostData, ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostError, ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostResponse, TranscribeAudioApiTranscribePostData, TranscribeAudioApiTranscribePostError, TranscribeAudioApiTranscribePostResponse, UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchData, UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchError, UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchResponse, UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchData, UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchError, UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchResponse, UploadImageApiAssetsImageUploadPostData, UploadImageApiAssetsImageUploadPostError, UploadImageApiAssetsImageUploadPostResponse, UploadImageApiImagesUploadPostData, UploadImageApiImagesUploadPostError, UploadImageApiImagesUploadPostResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const pingApiPingGetQueryKey = (options?: Options<PingApiPingGetData>) => createQueryKey('pingApiPingGet', options);

/**
 * Ping
 *
 * Simple ping endpoint for auth check and health monitoring
 */
export const pingApiPingGetOptions = (options?: Options<PingApiPingGetData>) => queryOptions<PingApiPingGetResponse, AxiosError<PingApiPingGetError>, PingApiPingGetResponse, ReturnType<typeof pingApiPingGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pingApiPingGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pingApiPingGetQueryKey(options)
});

export const listUsersApiAdminUsersGetQueryKey = (options?: Options<ListUsersApiAdminUsersGetData>) => createQueryKey('listUsersApiAdminUsersGet', options);

/**
 * List Users
 *
 * List and search platform users. Admin only.
 */
export const listUsersApiAdminUsersGetOptions = (options?: Options<ListUsersApiAdminUsersGetData>) => queryOptions<ListUsersApiAdminUsersGetResponse, AxiosError<ListUsersApiAdminUsersGetError>, ListUsersApiAdminUsersGetResponse, ReturnType<typeof listUsersApiAdminUsersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listUsersApiAdminUsersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUsersApiAdminUsersGetQueryKey(options)
});

/**
 * Update Billing Exempt
 *
 * Toggle a user's billing_exempt status. Admin only.
 */
export const updateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchMutation = (options?: Partial<Options<UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchData>>): UseMutationOptions<UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchResponse, AxiosError<UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchError>, Options<UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchResponse, AxiosError<UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchError>, Options<UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrgsApiAdminOrgsGetQueryKey = (options?: Options<ListOrgsApiAdminOrgsGetData>) => createQueryKey('listOrgsApiAdminOrgsGet', options);

/**
 * List Orgs
 *
 * List and search organizations. Admin only.
 */
export const listOrgsApiAdminOrgsGetOptions = (options?: Options<ListOrgsApiAdminOrgsGetData>) => queryOptions<ListOrgsApiAdminOrgsGetResponse, AxiosError<ListOrgsApiAdminOrgsGetError>, ListOrgsApiAdminOrgsGetResponse, ReturnType<typeof listOrgsApiAdminOrgsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrgsApiAdminOrgsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrgsApiAdminOrgsGetQueryKey(options)
});

/**
 * Update Org Billing Exempt
 *
 * Toggle an organization's billing_exempt status. Admin only.
 */
export const updateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchMutation = (options?: Partial<Options<UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchData>>): UseMutationOptions<UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchResponse, AxiosError<UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchError>, Options<UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchResponse, AxiosError<UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchError>, Options<UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAssetsApiAssetsGetQueryKey = (options?: Options<ListAssetsApiAssetsGetData>) => createQueryKey('listAssetsApiAssetsGet', options);

/**
 * List Assets
 *
 * List assets visible to the current user, newest first.
 *
 * Always returns the user's personal assets. When the request has an
 * active paid-org context, every asset shared with that org is also
 * returned. The frontend splits the result by ``org_id`` into the
 * "My Assets" and "ORG_NAME's Assets" sections.
 */
export const listAssetsApiAssetsGetOptions = (options?: Options<ListAssetsApiAssetsGetData>) => queryOptions<ListAssetsApiAssetsGetResponse, AxiosError<ListAssetsApiAssetsGetError>, ListAssetsApiAssetsGetResponse, ReturnType<typeof listAssetsApiAssetsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAssetsApiAssetsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAssetsApiAssetsGetQueryKey(options)
});

/**
 * Create Asset
 *
 * Save a reusable asset (e.g. a color) owned by the current user.
 *
 * Assets are always created as personal; sharing with an org happens
 * after the fact via ``POST /api/assets/{id}/share-with-org``.
 */
export const createAssetApiAssetsPostMutation = (options?: Partial<Options<CreateAssetApiAssetsPostData>>): UseMutationOptions<CreateAssetApiAssetsPostResponse, AxiosError<CreateAssetApiAssetsPostError>, Options<CreateAssetApiAssetsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateAssetApiAssetsPostResponse, AxiosError<CreateAssetApiAssetsPostError>, Options<CreateAssetApiAssetsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAssetApiAssetsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Image Asset
 *
 * Upload an image and save it as a reusable asset.
 *
 * Accepts JPEG, PNG, and WebP files. The image is stored in the public
 * bucket and the asset's ``value`` is its public URL. Like colors, image
 * assets are always created as personal.
 */
export const createImageAssetApiAssetsImagePostMutation = (options?: Partial<Options<CreateImageAssetApiAssetsImagePostData>>): UseMutationOptions<CreateImageAssetApiAssetsImagePostResponse, AxiosError<CreateImageAssetApiAssetsImagePostError>, Options<CreateImageAssetApiAssetsImagePostData>> => {
    const mutationOptions: UseMutationOptions<CreateImageAssetApiAssetsImagePostResponse, AxiosError<CreateImageAssetApiAssetsImagePostError>, Options<CreateImageAssetApiAssetsImagePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createImageAssetApiAssetsImagePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Image
 *
 * Store an image without saving it to the asset library.
 *
 * Backs one-time component replacements: the caller needs a durable URL to
 * attach to the design, but no ``Asset`` row appears in the gallery.
 * Accepts the same formats as ``POST /api/assets/image``.
 */
export const uploadImageApiAssetsImageUploadPostMutation = (options?: Partial<Options<UploadImageApiAssetsImageUploadPostData>>): UseMutationOptions<UploadImageApiAssetsImageUploadPostResponse, AxiosError<UploadImageApiAssetsImageUploadPostError>, Options<UploadImageApiAssetsImageUploadPostData>> => {
    const mutationOptions: UseMutationOptions<UploadImageApiAssetsImageUploadPostResponse, AxiosError<UploadImageApiAssetsImageUploadPostError>, Options<UploadImageApiAssetsImageUploadPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadImageApiAssetsImageUploadPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCatalogApiAssetsCatalogGetQueryKey = (options?: Options<ListCatalogApiAssetsCatalogGetData>) => createQueryKey('listCatalogApiAssetsCatalogGet', options);

/**
 * List Catalog
 *
 * List manufacturer assets for the Source screen, one page at a time.
 *
 * Every item says whether the current user has already saved it to their
 * library. Repeat ``manufacturer`` to narrow to any of several manufacturers,
 * and ``category_id`` to any of several categories; the two combine.
 * Ordered by manufacturer, then name; with a search ``q``, only the products
 * it finds, best fit first.
 */
export const listCatalogApiAssetsCatalogGetOptions = (options?: Options<ListCatalogApiAssetsCatalogGetData>) => queryOptions<ListCatalogApiAssetsCatalogGetResponse, AxiosError<ListCatalogApiAssetsCatalogGetError>, ListCatalogApiAssetsCatalogGetResponse, ReturnType<typeof listCatalogApiAssetsCatalogGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCatalogApiAssetsCatalogGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCatalogApiAssetsCatalogGetQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listCatalogApiAssetsCatalogGetInfiniteQueryKey = (options?: Options<ListCatalogApiAssetsCatalogGetData>): QueryKey<Options<ListCatalogApiAssetsCatalogGetData>> => createQueryKey('listCatalogApiAssetsCatalogGet', options, true);

/**
 * List Catalog
 *
 * List manufacturer assets for the Source screen, one page at a time.
 *
 * Every item says whether the current user has already saved it to their
 * library. Repeat ``manufacturer`` to narrow to any of several manufacturers,
 * and ``category_id`` to any of several categories; the two combine.
 * Ordered by manufacturer, then name; with a search ``q``, only the products
 * it finds, best fit first.
 */
export const listCatalogApiAssetsCatalogGetInfiniteOptions = (options?: Options<ListCatalogApiAssetsCatalogGetData>) => infiniteQueryOptions<ListCatalogApiAssetsCatalogGetResponse, AxiosError<ListCatalogApiAssetsCatalogGetError>, InfiniteData<ListCatalogApiAssetsCatalogGetResponse>, QueryKey<Options<ListCatalogApiAssetsCatalogGetData>>, number | Pick<QueryKey<Options<ListCatalogApiAssetsCatalogGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListCatalogApiAssetsCatalogGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listCatalogApiAssetsCatalogGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCatalogApiAssetsCatalogGetInfiniteQueryKey(options)
});

export const listCatalogManufacturersApiAssetsCatalogManufacturersGetQueryKey = (options?: Options<ListCatalogManufacturersApiAssetsCatalogManufacturersGetData>) => createQueryKey('listCatalogManufacturersApiAssetsCatalogManufacturersGet', options);

/**
 * List Catalog Manufacturers
 *
 * List the catalog's manufacturers with their product counts, A to Z.
 *
 * Counts are of the products in the selected categories (``category_id``,
 * repeatable) that the search ``q`` finds, so they say what selecting a
 * manufacturer would show. They ignore the manufacturer selection itself,
 * so the list doesn't change as manufacturers are toggled.
 */
export const listCatalogManufacturersApiAssetsCatalogManufacturersGetOptions = (options?: Options<ListCatalogManufacturersApiAssetsCatalogManufacturersGetData>) => queryOptions<ListCatalogManufacturersApiAssetsCatalogManufacturersGetResponse, AxiosError<ListCatalogManufacturersApiAssetsCatalogManufacturersGetError>, ListCatalogManufacturersApiAssetsCatalogManufacturersGetResponse, ReturnType<typeof listCatalogManufacturersApiAssetsCatalogManufacturersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCatalogManufacturersApiAssetsCatalogManufacturersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCatalogManufacturersApiAssetsCatalogManufacturersGetQueryKey(options)
});

export const listCatalogCategoriesApiAssetsCatalogCategoriesGetQueryKey = (options?: Options<ListCatalogCategoriesApiAssetsCatalogCategoriesGetData>) => createQueryKey('listCatalogCategoriesApiAssetsCatalogCategoriesGet', options);

/**
 * List Catalog Categories
 *
 * List the catalog categories that hold products, most populated first.
 *
 * Counts are of the selected manufacturers' products (``manufacturer``,
 * repeatable) that the search ``q`` finds, mirroring the manufacturer list;
 * the order is the whole
 * catalog's, so it doesn't change with the selection. A category nothing
 * has been placed in (see ``scripts/categorize_catalog.py``) is left out.
 */
export const listCatalogCategoriesApiAssetsCatalogCategoriesGetOptions = (options?: Options<ListCatalogCategoriesApiAssetsCatalogCategoriesGetData>) => queryOptions<ListCatalogCategoriesApiAssetsCatalogCategoriesGetResponse, AxiosError<ListCatalogCategoriesApiAssetsCatalogCategoriesGetError>, ListCatalogCategoriesApiAssetsCatalogCategoriesGetResponse, ReturnType<typeof listCatalogCategoriesApiAssetsCatalogCategoriesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCatalogCategoriesApiAssetsCatalogCategoriesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCatalogCategoriesApiAssetsCatalogCategoriesGetQueryKey(options)
});

/**
 * Add Asset To Library
 *
 * Save a manufacturer asset into the current user's asset library.
 *
 * Idempotent. Returns 404 if the asset is missing or isn't a manufacturer
 * asset.
 */
export const addAssetToLibraryApiAssetsAssetIdLibraryPostMutation = (options?: Partial<Options<AddAssetToLibraryApiAssetsAssetIdLibraryPostData>>): UseMutationOptions<AddAssetToLibraryApiAssetsAssetIdLibraryPostResponse, AxiosError<AddAssetToLibraryApiAssetsAssetIdLibraryPostError>, Options<AddAssetToLibraryApiAssetsAssetIdLibraryPostData>> => {
    const mutationOptions: UseMutationOptions<AddAssetToLibraryApiAssetsAssetIdLibraryPostResponse, AxiosError<AddAssetToLibraryApiAssetsAssetIdLibraryPostError>, Options<AddAssetToLibraryApiAssetsAssetIdLibraryPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addAssetToLibraryApiAssetsAssetIdLibraryPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Share Asset With Org
 *
 * Promote a personal asset to the user's active org.
 *
 * Returns 400 if there is no active org context, and 404 if the asset
 * is missing, owned by another user, or already shared.
 */
export const shareAssetWithOrgApiAssetsAssetIdShareWithOrgPostMutation = (options?: Partial<Options<ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostData>>): UseMutationOptions<ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostResponse, AxiosError<ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostError>, Options<ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostData>> => {
    const mutationOptions: UseMutationOptions<ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostResponse, AxiosError<ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostError>, Options<ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareAssetWithOrgApiAssetsAssetIdShareWithOrgPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Project
 *
 * Create a project folder.
 *
 * When ``parent_project_id`` resolves to an org-shared folder, the new
 * folder inherits the parent's ``org_id`` so the whole subtree is
 * reachable by every member of the org.
 */
export const createProjectApiProjectsPostMutation = (options?: Partial<Options<CreateProjectApiProjectsPostData>>): UseMutationOptions<CreateProjectApiProjectsPostResponse, AxiosError<CreateProjectApiProjectsPostError>, Options<CreateProjectApiProjectsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectApiProjectsPostResponse, AxiosError<CreateProjectApiProjectsPostError>, Options<CreateProjectApiProjectsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProjectApiProjectsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rename Project
 *
 * Rename a project the user can reach (own or via org-share).
 *
 * The org-shared root folder cannot be renamed — its display name is
 * derived from the live Clerk org name.
 */
export const renameProjectApiProjectsProjectIdPatchMutation = (options?: Partial<Options<RenameProjectApiProjectsProjectIdPatchData>>): UseMutationOptions<RenameProjectApiProjectsProjectIdPatchResponse, AxiosError<RenameProjectApiProjectsProjectIdPatchError>, Options<RenameProjectApiProjectsProjectIdPatchData>> => {
    const mutationOptions: UseMutationOptions<RenameProjectApiProjectsProjectIdPatchResponse, AxiosError<RenameProjectApiProjectsProjectIdPatchError>, Options<RenameProjectApiProjectsProjectIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await renameProjectApiProjectsProjectIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProjectAssetsApiProjectsProjectIdAssetsGetQueryKey = (options: Options<ListProjectAssetsApiProjectsProjectIdAssetsGetData>) => createQueryKey('listProjectAssetsApiProjectsProjectIdAssetsGet', options);

/**
 * List Project Assets
 *
 * List a project's assets, used (solid) first then unused (dashed).
 *
 * Combines manually attached assets with assets derived from the project's
 * designs; each carries a ``used`` flag for the UI styling.
 */
export const listProjectAssetsApiProjectsProjectIdAssetsGetOptions = (options: Options<ListProjectAssetsApiProjectsProjectIdAssetsGetData>) => queryOptions<ListProjectAssetsApiProjectsProjectIdAssetsGetResponse, AxiosError<ListProjectAssetsApiProjectsProjectIdAssetsGetError>, ListProjectAssetsApiProjectsProjectIdAssetsGetResponse, ReturnType<typeof listProjectAssetsApiProjectsProjectIdAssetsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectAssetsApiProjectsProjectIdAssetsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectAssetsApiProjectsProjectIdAssetsGetQueryKey(options)
});

/**
 * Attach Project Asset
 *
 * Attach an existing asset to a project the user can reach.
 *
 * Assets live in the user's global library; this only records membership.
 * Idempotent — attaching an asset already in the project succeeds without
 * duplicating it.
 */
export const attachProjectAssetApiProjectsProjectIdAssetsPostMutation = (options?: Partial<Options<AttachProjectAssetApiProjectsProjectIdAssetsPostData>>): UseMutationOptions<AttachProjectAssetApiProjectsProjectIdAssetsPostResponse, AxiosError<AttachProjectAssetApiProjectsProjectIdAssetsPostError>, Options<AttachProjectAssetApiProjectsProjectIdAssetsPostData>> => {
    const mutationOptions: UseMutationOptions<AttachProjectAssetApiProjectsProjectIdAssetsPostResponse, AxiosError<AttachProjectAssetApiProjectsProjectIdAssetsPostError>, Options<AttachProjectAssetApiProjectsProjectIdAssetsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attachProjectAssetApiProjectsProjectIdAssetsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete All Sessions
 *
 * Delete all sessions and their associated images for the current user.
 *
 * Personal-only on purpose: shared org sessions are out of scope for
 * bulk clear, so this endpoint takes no org context.
 */
export const deleteAllSessionsApiSessionsDeleteMutation = (options?: Partial<Options<DeleteAllSessionsApiSessionsDeleteData>>): UseMutationOptions<DeleteAllSessionsApiSessionsDeleteResponse, AxiosError<DeleteAllSessionsApiSessionsDeleteError>, Options<DeleteAllSessionsApiSessionsDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteAllSessionsApiSessionsDeleteResponse, AxiosError<DeleteAllSessionsApiSessionsDeleteError>, Options<DeleteAllSessionsApiSessionsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAllSessionsApiSessionsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSessionsApiSessionsGetQueryKey = (options?: Options<ListSessionsApiSessionsGetData>) => createQueryKey('listSessionsApiSessionsGet', options);

/**
 * List Sessions
 *
 * Get paginated list of accessible sessions with their latest image.
 */
export const listSessionsApiSessionsGetOptions = (options?: Options<ListSessionsApiSessionsGetData>) => queryOptions<ListSessionsApiSessionsGetResponse, AxiosError<ListSessionsApiSessionsGetError>, ListSessionsApiSessionsGetResponse, ReturnType<typeof listSessionsApiSessionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSessionsApiSessionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSessionsApiSessionsGetQueryKey(options)
});

export const listSessionsApiSessionsGetInfiniteQueryKey = (options?: Options<ListSessionsApiSessionsGetData>): QueryKey<Options<ListSessionsApiSessionsGetData>> => createQueryKey('listSessionsApiSessionsGet', options, true);

/**
 * List Sessions
 *
 * Get paginated list of accessible sessions with their latest image.
 */
export const listSessionsApiSessionsGetInfiniteOptions = (options?: Options<ListSessionsApiSessionsGetData>) => infiniteQueryOptions<ListSessionsApiSessionsGetResponse, AxiosError<ListSessionsApiSessionsGetError>, InfiniteData<ListSessionsApiSessionsGetResponse>, QueryKey<Options<ListSessionsApiSessionsGetData>>, number | Pick<QueryKey<Options<ListSessionsApiSessionsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListSessionsApiSessionsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listSessionsApiSessionsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSessionsApiSessionsGetInfiniteQueryKey(options)
});

export const getGalleryTreeApiSessionsGalleryTreeGetQueryKey = (options?: Options<GetGalleryTreeApiSessionsGalleryTreeGetData>) => createQueryKey('getGalleryTreeApiSessionsGalleryTreeGet', options);

/**
 * Get Gallery Tree
 *
 * Get projects and sessions for the gallery project drawer.
 *
 * When the request has an active paid-org context, the org's shared root
 * folder is auto-created on first call and rendered as
 * ``{Org Name}'s Projects`` alongside personal projects.
 */
export const getGalleryTreeApiSessionsGalleryTreeGetOptions = (options?: Options<GetGalleryTreeApiSessionsGalleryTreeGetData>) => queryOptions<GetGalleryTreeApiSessionsGalleryTreeGetResponse, AxiosError<GetGalleryTreeApiSessionsGalleryTreeGetError>, GetGalleryTreeApiSessionsGalleryTreeGetResponse, ReturnType<typeof getGalleryTreeApiSessionsGalleryTreeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGalleryTreeApiSessionsGalleryTreeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGalleryTreeApiSessionsGalleryTreeGetQueryKey(options)
});

/**
 * Move Session To Project
 *
 * Assign a design session to a project folder.
 *
 * Moving a session into the org-shared folder grants org-wide access;
 * moving it back out revokes it.
 */
export const moveSessionToProjectApiSessionsSessionIdProjectPatchMutation = (options?: Partial<Options<MoveSessionToProjectApiSessionsSessionIdProjectPatchData>>): UseMutationOptions<MoveSessionToProjectApiSessionsSessionIdProjectPatchResponse, AxiosError<MoveSessionToProjectApiSessionsSessionIdProjectPatchError>, Options<MoveSessionToProjectApiSessionsSessionIdProjectPatchData>> => {
    const mutationOptions: UseMutationOptions<MoveSessionToProjectApiSessionsSessionIdProjectPatchResponse, AxiosError<MoveSessionToProjectApiSessionsSessionIdProjectPatchError>, Options<MoveSessionToProjectApiSessionsSessionIdProjectPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await moveSessionToProjectApiSessionsSessionIdProjectPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Session
 *
 * Delete a single session and its images.
 *
 * Org members can delete sessions in any project shared with their org.
 */
export const deleteSessionApiSessionsSessionIdDeleteMutation = (options?: Partial<Options<DeleteSessionApiSessionsSessionIdDeleteData>>): UseMutationOptions<DeleteSessionApiSessionsSessionIdDeleteResponse, AxiosError<DeleteSessionApiSessionsSessionIdDeleteError>, Options<DeleteSessionApiSessionsSessionIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteSessionApiSessionsSessionIdDeleteResponse, AxiosError<DeleteSessionApiSessionsSessionIdDeleteError>, Options<DeleteSessionApiSessionsSessionIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSessionApiSessionsSessionIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSessionWithHierarchyApiSessionsSessionIdGetQueryKey = (options: Options<GetSessionWithHierarchyApiSessionsSessionIdGetData>) => createQueryKey('getSessionWithHierarchyApiSessionsSessionIdGet', options);

/**
 * Get Session With Hierarchy
 *
 * Get all images in a session organized by iteration hierarchy.
 */
export const getSessionWithHierarchyApiSessionsSessionIdGetOptions = (options: Options<GetSessionWithHierarchyApiSessionsSessionIdGetData>) => queryOptions<GetSessionWithHierarchyApiSessionsSessionIdGetResponse, AxiosError<GetSessionWithHierarchyApiSessionsSessionIdGetError>, GetSessionWithHierarchyApiSessionsSessionIdGetResponse, ReturnType<typeof getSessionWithHierarchyApiSessionsSessionIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSessionWithHierarchyApiSessionsSessionIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSessionWithHierarchyApiSessionsSessionIdGetQueryKey(options)
});

/**
 * Rename Session
 *
 * Rename a session the user can reach (own or via org-share).
 */
export const renameSessionApiSessionsSessionIdPatchMutation = (options?: Partial<Options<RenameSessionApiSessionsSessionIdPatchData>>): UseMutationOptions<RenameSessionApiSessionsSessionIdPatchResponse, AxiosError<RenameSessionApiSessionsSessionIdPatchError>, Options<RenameSessionApiSessionsSessionIdPatchData>> => {
    const mutationOptions: UseMutationOptions<RenameSessionApiSessionsSessionIdPatchResponse, AxiosError<RenameSessionApiSessionsSessionIdPatchError>, Options<RenameSessionApiSessionsSessionIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await renameSessionApiSessionsSessionIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listImagesApiImagesGetQueryKey = (options?: Options<ListImagesApiImagesGetData>) => createQueryKey('listImagesApiImagesGet', options);

/**
 * List Images
 *
 * Get paginated list of images accessible to the current user.
 */
export const listImagesApiImagesGetOptions = (options?: Options<ListImagesApiImagesGetData>) => queryOptions<ListImagesApiImagesGetResponse, AxiosError<ListImagesApiImagesGetError>, ListImagesApiImagesGetResponse, ReturnType<typeof listImagesApiImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listImagesApiImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listImagesApiImagesGetQueryKey(options)
});

export const listImagesApiImagesGetInfiniteQueryKey = (options?: Options<ListImagesApiImagesGetData>): QueryKey<Options<ListImagesApiImagesGetData>> => createQueryKey('listImagesApiImagesGet', options, true);

/**
 * List Images
 *
 * Get paginated list of images accessible to the current user.
 */
export const listImagesApiImagesGetInfiniteOptions = (options?: Options<ListImagesApiImagesGetData>) => infiniteQueryOptions<ListImagesApiImagesGetResponse, AxiosError<ListImagesApiImagesGetError>, InfiniteData<ListImagesApiImagesGetResponse>, QueryKey<Options<ListImagesApiImagesGetData>>, number | Pick<QueryKey<Options<ListImagesApiImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListImagesApiImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listImagesApiImagesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listImagesApiImagesGetInfiniteQueryKey(options)
});

/**
 * Upload Image
 *
 * Upload an image as the root of a new session, without generation.
 *
 * The uploaded image becomes the base for refinement: design type is
 * detected from the image, a session is created, and the returned image
 * has no parameter groups so the refine screen auto-extracts them.
 */
export const uploadImageApiImagesUploadPostMutation = (options?: Partial<Options<UploadImageApiImagesUploadPostData>>): UseMutationOptions<UploadImageApiImagesUploadPostResponse, AxiosError<UploadImageApiImagesUploadPostError>, Options<UploadImageApiImagesUploadPostData>> => {
    const mutationOptions: UseMutationOptions<UploadImageApiImagesUploadPostResponse, AxiosError<UploadImageApiImagesUploadPostError>, Options<UploadImageApiImagesUploadPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadImageApiImagesUploadPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Image
 *
 * Delete an image. Org members can delete images in org-shared folders.
 */
export const deleteImageApiImagesImageIdDeleteMutation = (options?: Partial<Options<DeleteImageApiImagesImageIdDeleteData>>): UseMutationOptions<DeleteImageApiImagesImageIdDeleteResponse, AxiosError<DeleteImageApiImagesImageIdDeleteError>, Options<DeleteImageApiImagesImageIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteImageApiImagesImageIdDeleteResponse, AxiosError<DeleteImageApiImagesImageIdDeleteError>, Options<DeleteImageApiImagesImageIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteImageApiImagesImageIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImageByIdApiImagesImageIdGetQueryKey = (options: Options<GetImageByIdApiImagesImageIdGetData>) => createQueryKey('getImageByIdApiImagesImageIdGet', options);

/**
 * Get Image By Id
 *
 * Get image by ID (user must reach it via ownership or org-share).
 */
export const getImageByIdApiImagesImageIdGetOptions = (options: Options<GetImageByIdApiImagesImageIdGetData>) => queryOptions<GetImageByIdApiImagesImageIdGetResponse, AxiosError<GetImageByIdApiImagesImageIdGetError>, GetImageByIdApiImagesImageIdGetResponse, ReturnType<typeof getImageByIdApiImagesImageIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageByIdApiImagesImageIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageByIdApiImagesImageIdGetQueryKey(options)
});

export const getImageAssetsApiImagesImageIdAssetsGetQueryKey = (options: Options<GetImageAssetsApiImagesImageIdAssetsGetData>) => createQueryKey('getImageAssetsApiImagesImageIdAssetsGet', options);

/**
 * Get Image Assets
 *
 * List the assets used within this image (iteration), newest first.
 *
 * Derived from the assets the user picked for color parameters during
 * refinement. Powers the design-details "Assets" section.
 */
export const getImageAssetsApiImagesImageIdAssetsGetOptions = (options: Options<GetImageAssetsApiImagesImageIdAssetsGetData>) => queryOptions<GetImageAssetsApiImagesImageIdAssetsGetResponse, AxiosError<GetImageAssetsApiImagesImageIdAssetsGetError>, GetImageAssetsApiImagesImageIdAssetsGetResponse, ReturnType<typeof getImageAssetsApiImagesImageIdAssetsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageAssetsApiImagesImageIdAssetsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageAssetsApiImagesImageIdAssetsGetQueryKey(options)
});

/**
 * Save Image As Asset
 *
 * Save a generated design image into the caller's asset library.
 *
 * Copies the stored PNG into the public asset bucket rather than making the
 * client download and re-upload it. Like every other asset, the new one is
 * personal until it is explicitly shared with an org.
 */
export const saveImageAsAssetApiImagesImageIdSaveAsAssetPostMutation = (options?: Partial<Options<SaveImageAsAssetApiImagesImageIdSaveAsAssetPostData>>): UseMutationOptions<SaveImageAsAssetApiImagesImageIdSaveAsAssetPostResponse, AxiosError<SaveImageAsAssetApiImagesImageIdSaveAsAssetPostError>, Options<SaveImageAsAssetApiImagesImageIdSaveAsAssetPostData>> => {
    const mutationOptions: UseMutationOptions<SaveImageAsAssetApiImagesImageIdSaveAsAssetPostResponse, AxiosError<SaveImageAsAssetApiImagesImageIdSaveAsAssetPostError>, Options<SaveImageAsAssetApiImagesImageIdSaveAsAssetPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveImageAsAssetApiImagesImageIdSaveAsAssetPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadImageApiImagesImageIdDownloadGetQueryKey = (options: Options<DownloadImageApiImagesImageIdDownloadGetData>) => createQueryKey('downloadImageApiImagesImageIdDownloadGet', options);

/**
 * Download Image
 *
 * Download image file. Bypasses CORS by proxying through API.
 */
export const downloadImageApiImagesImageIdDownloadGetOptions = (options: Options<DownloadImageApiImagesImageIdDownloadGetData>) => queryOptions<unknown, AxiosError<DownloadImageApiImagesImageIdDownloadGetError>, unknown, ReturnType<typeof downloadImageApiImagesImageIdDownloadGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadImageApiImagesImageIdDownloadGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadImageApiImagesImageIdDownloadGetQueryKey(options)
});

export const downloadUpscaledImageApiImagesImageIdDownloadUpscaledGetQueryKey = (options: Options<DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetData>) => createQueryKey('downloadUpscaledImageApiImagesImageIdDownloadUpscaledGet', options);

/**
 * Download Upscaled Image
 *
 * Download an upscaled copy of the image (2x or 4x via Topaz Gigapixel).
 *
 * Paid-plan only, unlike the rest of the design endpoints: the free
 * allowance buys generations, not Topaz megapixels. The original-resolution
 * download beside it stays open to everyone.
 */
export const downloadUpscaledImageApiImagesImageIdDownloadUpscaledGetOptions = (options: Options<DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetData>) => queryOptions<unknown, AxiosError<DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetError>, unknown, ReturnType<typeof downloadUpscaledImageApiImagesImageIdDownloadUpscaledGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadUpscaledImageApiImagesImageIdDownloadUpscaledGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadUpscaledImageApiImagesImageIdDownloadUpscaledGetQueryKey(options)
});

/**
 * Extract Parameters From Image
 *
 * Extract design parameters from an image using vision model.
 */
export const extractParametersFromImageApiImagesImageIdParametersPostMutation = (options?: Partial<Options<ExtractParametersFromImageApiImagesImageIdParametersPostData>>): UseMutationOptions<ExtractParametersFromImageApiImagesImageIdParametersPostResponse, AxiosError<ExtractParametersFromImageApiImagesImageIdParametersPostError>, Options<ExtractParametersFromImageApiImagesImageIdParametersPostData>> => {
    const mutationOptions: UseMutationOptions<ExtractParametersFromImageApiImagesImageIdParametersPostResponse, AxiosError<ExtractParametersFromImageApiImagesImageIdParametersPostError>, Options<ExtractParametersFromImageApiImagesImageIdParametersPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await extractParametersFromImageApiImagesImageIdParametersPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Expand Group Parameters
 *
 * Expand parameters within a specific element group using vision analysis.
 */
export const expandGroupParametersApiImagesImageIdParametersExpandGroupPostMutation = (options?: Partial<Options<ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostData>>): UseMutationOptions<ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostResponse, AxiosError<ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostError>, Options<ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostData>> => {
    const mutationOptions: UseMutationOptions<ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostResponse, AxiosError<ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostError>, Options<ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await expandGroupParametersApiImagesImageIdParametersExpandGroupPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Expand Elements
 *
 * Expand with new element groups using vision analysis.
 */
export const expandElementsApiImagesImageIdParametersExpandElementsPostMutation = (options?: Partial<Options<ExpandElementsApiImagesImageIdParametersExpandElementsPostData>>): UseMutationOptions<ExpandElementsApiImagesImageIdParametersExpandElementsPostResponse, AxiosError<ExpandElementsApiImagesImageIdParametersExpandElementsPostError>, Options<ExpandElementsApiImagesImageIdParametersExpandElementsPostData>> => {
    const mutationOptions: UseMutationOptions<ExpandElementsApiImagesImageIdParametersExpandElementsPostResponse, AxiosError<ExpandElementsApiImagesImageIdParametersExpandElementsPostError>, Options<ExpandElementsApiImagesImageIdParametersExpandElementsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await expandElementsApiImagesImageIdParametersExpandElementsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImageIterationPathApiImagesImageIdIterationPathGetQueryKey = (options: Options<GetImageIterationPathApiImagesImageIdIterationPathGetData>) => createQueryKey('getImageIterationPathApiImagesImageIdIterationPathGet', options);

/**
 * Get Image Iteration Path
 *
 * Get the full iteration path from root to a specific image.
 */
export const getImageIterationPathApiImagesImageIdIterationPathGetOptions = (options: Options<GetImageIterationPathApiImagesImageIdIterationPathGetData>) => queryOptions<GetImageIterationPathApiImagesImageIdIterationPathGetResponse, AxiosError<GetImageIterationPathApiImagesImageIdIterationPathGetError>, GetImageIterationPathApiImagesImageIdIterationPathGetResponse, ReturnType<typeof getImageIterationPathApiImagesImageIdIterationPathGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageIterationPathApiImagesImageIdIterationPathGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageIterationPathApiImagesImageIdIterationPathGetQueryKey(options)
});

/**
 * Transcribe Audio
 *
 * Transcribe an uploaded audio file to text using Gemini.
 *
 * Accepts audio files in common formats (MP3, WAV, M4A, WebM, OGG).
 * Returns the transcribed text.
 */
export const transcribeAudioApiTranscribePostMutation = (options?: Partial<Options<TranscribeAudioApiTranscribePostData>>): UseMutationOptions<TranscribeAudioApiTranscribePostResponse, AxiosError<TranscribeAudioApiTranscribePostError>, Options<TranscribeAudioApiTranscribePostData>> => {
    const mutationOptions: UseMutationOptions<TranscribeAudioApiTranscribePostResponse, AxiosError<TranscribeAudioApiTranscribePostError>, Options<TranscribeAudioApiTranscribePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transcribeAudioApiTranscribePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyStatusApiUsersMeGetQueryKey = (options?: Options<GetMyStatusApiUsersMeGetData>) => createQueryKey('getMyStatusApiUsersMeGet', options);

/**
 * Get My Status
 *
 * Get the current user's free-plan usage and onboarding status.
 */
export const getMyStatusApiUsersMeGetOptions = (options?: Options<GetMyStatusApiUsersMeGetData>) => queryOptions<GetMyStatusApiUsersMeGetResponse, AxiosError<GetMyStatusApiUsersMeGetError>, GetMyStatusApiUsersMeGetResponse, ReturnType<typeof getMyStatusApiUsersMeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMyStatusApiUsersMeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyStatusApiUsersMeGetQueryKey(options)
});

/**
 * Mark Welcome Video Seen
 *
 * Record that the onboarding welcome video has been shown to this user.
 *
 * Authenticated-only, not subscription-gated: onboarding isn't a design feature.
 */
export const markWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostMutation = (options?: Partial<Options<MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostData>>): UseMutationOptions<MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostResponse, AxiosError<MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostError>, Options<MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostData>> => {
    const mutationOptions: UseMutationOptions<MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostResponse, AxiosError<MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostError>, Options<MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Handle Clerk Webhook
 *
 * Receive and process Clerk webhook events.
 *
 * Verifies the Svix signature, then dispatches to the appropriate
 * handler to sync data with Attio CRM and our own user records.
 */
export const handleClerkWebhookApiWebhooksClerkPostMutation = (options?: Partial<Options<HandleClerkWebhookApiWebhooksClerkPostData>>): UseMutationOptions<unknown, AxiosError<HandleClerkWebhookApiWebhooksClerkPostError>, Options<HandleClerkWebhookApiWebhooksClerkPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<HandleClerkWebhookApiWebhooksClerkPostError>, Options<HandleClerkWebhookApiWebhooksClerkPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleClerkWebhookApiWebhooksClerkPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const healthCheckHealthGetQueryKey = (options?: Options<HealthCheckHealthGetData>) => createQueryKey('healthCheckHealthGet', options);

/**
 * Health Check
 */
export const healthCheckHealthGetOptions = (options?: Options<HealthCheckHealthGetData>) => queryOptions<unknown, AxiosError<HealthCheckHealthGetError>, unknown, ReturnType<typeof healthCheckHealthGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthCheckHealthGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthCheckHealthGetQueryKey(options)
});
